import React from 'react';
import './FlexOfertas.css';
import { FaBoxOpen } from "react-icons/fa";
import { useNavigate } from 'react-router';

const FlexOpenbox = () => {
    const navigate = useNavigate()
    const country = process.env.REACT_APP_COUNTRY;

    return (
        <div className="flex-ofertas-container" style={{
            maxWidth: '1500px',
            display: 'flex',
            justifyContent: 'space-around'
        }}>
            <div className="text">
                <h2 style={{ fontWeight: 'bold', color: '#0d1821' }}>OUTLET</h2>
                <p style={{ fontWeight: 'bold', color: '#5e6472' }}>¡Encontrá precios increíbles cada día!</p>
            </div>

            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }} className='flex-ofertas-icons'>
                <FaBoxOpen size={'4em'} style={{ marginBottom: '3px', }} color="red" onClick={() => navigate('/openbox')} />
                <p style={{ fontWeight: 'bold', color: '#5e6472', marginBottom: '3px' }}>OUTLET</p>
                <div className="divider"></div>
            </div>
        </div>
    );
};

export default FlexOpenbox;